// extracted by mini-css-extract-plugin
export default {"NavContainer":"NavBar_NavContainer__xPopZ","imagen":"NavBar_imagen__hjvlD","contenedorSubTitulo":"NavBar_contenedorSubTitulo__n+RUy","subTitulo":"NavBar_subTitulo__qfQJF"};